import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useAtom } from 'jotai'
import { videoElementAtom } from './atoms'
import { Speaker2 } from '@styled-icons/fluentui-system-filled/Speaker2'
import { SpeakerMute } from '@styled-icons/fluentui-system-filled/SpeakerMute'

//* ========================== React Component =================================

const CardMuteToggle = (): JSX.Element => {
  const [isMuted, setMuted] = useState(false)
  const [videoElement] = useAtom(videoElementAtom)

  useEffect(() => {
    if (!videoElement) {
      return
    }

    videoElement.onvolumechange = () => {
      setMuted(videoElement.muted)
    }
  }, [videoElement])

  useEffect(() => {
    if (!videoElement) {
      return
    }

    setMuted(videoElement!.muted)
  }, [videoElement])

  return (
    <BlurredCircle
      onClick={() => {
        videoElement!.muted = !videoElement!.muted
      }}
    >
      <Wrapper>{isMuted ? <SpeakerMute /> : <Speaker2 />}</Wrapper>
    </BlurredCircle>
  )
}

export default CardMuteToggle

//* ========================= Styled Components  ===============================

const Wrapper = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  color: white;
`

const BlurredCircle = styled.div`
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.05);
  position: absolute;
  top: 10px;
  left: 10px;
  width: 25px;
  padding: 15px 15px 15px 15px;
  pointer-events: all;
  z-index: 1000;
  border-radius: 100%;
  display: inline-block;
  cursor: pointer;
`
